import Env from '@/common/constants/Env.json'
import EnvProd from '@/common/constants/Env_prod.json'
import EnvStage from '@/common/constants/Env_stage.json'
import Util from "@/common/utils/Util"
// import _ from "lodash";

let CODE_ENV_LIST = Env

if (process.env.VUE_APP_MODE === 'production') {
  CODE_ENV_LIST = EnvProd
} else if (process.env.VUE_APP_MODE === 'stage') {
  CODE_ENV_LIST = EnvStage
}

const CODE_SERVICE_TYPE = {
  ELECT: {
    label: '전력비 절감',
    value: 1
  },
  LABOR: {
    label: '인증',
    value: 2
  },
  LAB: {
    label: '연구소',
    value: 3
  }
}

const CODE_SERVICE_PROGRESS_STATUS = {
  A: {
    1: {
      label: '컨설팅 진행 (구두 협의)',
      value: 1
    },
    2: {
      label: '서류 안내 및 현장조사',
      value: 2
    },
    3: {
      label: '서류 수령 중',
      value: 3
    },
    4: {
      label: '한전 서류 제출',
      value: 4
    },
    5: {
      label: '접수중',
      value: 5
    },
    6: {
      label: '한전 승인',
      value: 6
    },
    7: {
      label: '한전 실사',
      value: 7
    },
    8: {
      label: '변경 확인중',
      value: 8
    },
    9: {
      label: '절감보고 및 사후관리',
      value: 9
    }
  },
  B: {
    1: {
      label: '컨설팅 진행 (구두 협의)',
      value: 1
    },
    2: {
      label: '서류 안내 및 현장조사',
      value: 2
    },
    3: {
      label: '서류 수령 중',
      value: 3
    },
    4: {
      label: '한전 서류 제출',
      value: 4
    },
    5: {
      label: '접수중',
      value: 5
    },
    6: {
      label: '한전 승인',
      value: 6
    },
    7: {
      label: '전기 공사',
      value: 7
    },
    8: {
      label: '변경 확인중',
      value: 8
    },
    9: {
      label: '한전 2차 서류 제출',
      value: 9
    },
    10: {
      label: '접수중',
      value: 10
    },
    11: {
      label: '전기 공사',
      value: 11
    },
    12: {
      label: '변경 확인중',
      value: 12
    },
    13: {
      label: '절감보고 및 사후관리',
      value: 13
    }
  },
  C: {
    1: {
      label: '컨설팅 진행 (구두 협의)',
      value: 1
    },
    2: {
      label: '서류 안내 및 현장조사',
      value: 2
    },
    3: {
      label: '서류 수령 중',
      value: 3
    },
    4: {
      label: '한전 서류 제출',
      value: 4
    },
    5: {
      label: '접수중',
      value: 5
    },
    6: {
      label: '한전 승인',
      value: 6
    },
    7: {
      label: '전기 공사',
      value: 7
    },
    8: {
      label: '변경 확인중',
      value: 8
    },
    9: {
      label: '한전 2차 서류 제출',
      value: 9
    },
    10: {
      label: '접수중',
      value: 10
    },
    11: {
      label: '전기 공사',
      value: 11
    },
    12: {
      label: '변경 확인중',
      value: 12
    },
    13: {
      label: '한전 3차 서류 제출',
      value: 13
    },
    14: {
      label: '접수중',
      value: 14
    },
    15: {
      label: '전기 공사',
      value: 15
    },
    16: {
      label: '변경 확인중',
      value: 16
    },
    17: {
      label: '절감보고 및 사후관리',
      value: 17
    }
  }
}

// const CODE_SERVICE_PROGRESS_STATUS = {
//   A: [
//     {
//       label: '컨설팅 진행 (구두 협의)',
//       value: 1
//     },
//     {
//       label: '서류 안내 및 현장조사',
//       value: 2
//     },
//     {
//       label: '서류 수령 중',
//       value: 3
//     },
//     {
//       label: '한전 서류 제출',
//       value: 4
//     },
//     {
//       label: '접수중',
//       value: 5
//     },
//     {
//       label: '한전 승인',
//       value: 6
//     },
//     {
//       label: '한전 실사',
//       value: 7
//     },
//     {
//       label: '변경 확인중',
//       value: 8
//     },
//     {
//       label: '절감보고 및 사후관리',
//       value: 9
//     }
//   ],
//   B: [
//     {
//       label: '컨설팅 진행 (구두 협의)',
//       value: 1
//     },
//     {
//       label: '서류 안내 및 현장조사',
//       value: 2
//     },
//     {
//       label: '서류 수령 중',
//       value: 3
//     },
//     {
//       label: '한전 서류 제출',
//       value: 4
//     },
//     {
//       label: '접수중',
//       value: 5
//     },
//     {
//       label: '한전 승인',
//       value: 6
//     },
//     {
//       label: '전기 공사',
//       value: 7
//     },
//     {
//       label: '변경 확인중',
//       value: 8
//     },
//     {
//       label: '한전 2차 서류 제출',
//       value: 9
//     },
//     {
//       label: '접수중',
//       value: 10
//     },
//     {
//       label: '전기 공사',
//       value: 11
//     },
//     {
//       label: '변경 확인중',
//       value: 12
//     },
//     {
//       label: '절감보고 및 사후관리',
//       value: 13
//     }
//   ],
//   C: [
//     {
//       label: '컨설팅 진행 (구두 협의)',
//       value: 1
//     },
//     {
//       label: '서류 안내 및 현장조사',
//       value: 2
//     },
//     {
//       label: '서류 수령 중',
//       value: 3
//     },
//     {
//       label: '한전 서류 제출',
//       value: 4
//     },
//     {
//       label: '접수중',
//       value: 5
//     },
//     {
//       label: '한전 승인',
//       value: 6
//     },
//     {
//       label: '전기 공사',
//       value: 7
//     },
//     {
//       label: '변경 확인중',
//       value: 8
//     },
//     {
//       label: '한전 2차 서류 제출',
//       value: 9
//     },
//     {
//       label: '접수중',
//       value: 10
//     },
//     {
//       label: '전기 공사',
//       value: 11
//     },
//     {
//       label: '변경 확인중',
//       value: 12
//     },
//     {
//       label: '한전 3차 서류 제출',
//       value: 13
//     },
//     {
//       label: '접수중',
//       value: 14
//     },
//     {
//       label: '전기 공사',
//       value: 15
//     },
//     {
//       label: '변경 확인중',
//       value: 16
//     },
//     {
//       label: '절감보고 및 사후관리',
//       value: 17
//     }
//   ]
// }

let windowObj
let vmFunction
let vmFunctionName
// let vmFunctionName
window.addEventListener('message', function ({data}) {
  if (!Util.isEmpty(data.operateName) && data.operateName === vmFunctionName) {
    vmFunction(data.data)
    if (windowObj) {
      windowObj.close();
    }
  }


  // vmFunction(params)
}, false)

const ConstCode = function () {
  return {
    CODE_ENV_LIST,
    CODE_SERVICE_TYPE,
    CODE_SERVICE_PROGRESS_STATUS
  }
}
export default ConstCode()
